import {useState, useEffect} from 'react';
import {useParams, Link} from "react-router-dom";
import {getDocs, collection, query, orderBy, where, setDoc, doc} from "firebase/firestore";
import { db } from '../firebase';
import like from "../img/like.svg";

export default function ProductCategory({user, isUser}) {
    const {id} = useParams();

    const [product, setProduct] = useState();
    const [isSort, setIsSort] = useState(false);
    const [sortValue, setSortValue] = useState();

    useEffect(() => {
        let productData = [];
        getDocs(query(collection(db, "products"), isSort && orderBy("price", sortValue))).then((snap) => {
            snap.forEach((item) => {
                if(item.data().category == String(id)){
                    productData.push(item.data());
                }
            })

            setProduct(productData);
        })
    }, [sortValue])

    function handleLike(prod, img, name, price, cat){
        setDoc(doc(db, `users/${user.uid}/wishlist`, String(prod)), {
            docName: prod,
            itemName: name,
            itemImg: img,
            itemPrice: price,
            category: cat
        }).then(() => {
            alert("Product added to wishlist");
        })
    }
  return (
    <div className='product-category'>
        <div className='breadcrumb'>
            <Link to = "/">Home</Link>
            <span>{'>'}</span>
            <Link to = {`/category/${id}`}>{id}</Link>
        </div>

        <div className='product-list'>
            <div className='list-top'>
                <h2>{id}</h2>
                <label>Sort By: <select defaultValue= "" value={sortValue} onChange = {e => {setSortValue(e.target.value); setIsSort(true)}}>
                    <option value= "" disabled>Sort By Product</option>
                    <option value= "asc">Price: Lowest to Highest</option>
                    <option value = "desc">Price: Highest to Lowest</option>
                </select></label>
            </div>
            {product && <div className='listing'>
                {product.map((item) => {
                    return <Link to = {`/category/${id}/${item.docName}`}><div className='listing-item'>
                        <img src = {item.img}/>
                        <p className='listing-name'>{item.name}</p>
                        <p className='listing-price'>₦{item.price}</p>
                        <button onClick={(e) =>{e.preventDefault(); handleLike(item.docName, item.img, item.name, item.price, item.category)}}><img src = {like}/></button>
                    </div></Link>
                })}
            </div>}
        </div>
    </div>
  )
}
